export const companyName = '上海白溪私募基金管理有限公司';

export const APIS = {
  LOGIN: '/login',
  REGISTER: '/register',
  LOGOUT: '/logout',
  angle: '/angles',
  report: '/reports',
  teach: '/teachs',
  NEWS: (path) => `/public/storage${path}/index.html?t=${+(new Date())}`,
}

export const DEFAULT_PARAMS = {
  page: 1,
  limit: 10,
}

export const INDEX_PARAMS = {
  page: 1,
  limit: 5,
}
